import React, { useState, useEffect } from "react";
import { Row,Col, Card, CardBody, Button } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import axios from "axios";
import * as url from "../../helpers/url_helper"
import { Config } from "helpers/backend_helper";
import GaugeComponent from 'react-gauge-component'

const Oerview = () => {
  const [data, setData] = useState([])
  const [dates, setDates] = useState([])
  const [amounts, setAmounts] = useState([])
  const [amountsz, setAmountsz] = useState([])
  const [amountse, setAmountse] = useState([])
  const [series1, setSeries1] = useState([])

  const [zztotal, setzztotal] = useState(0)
  const [eetotal, seteetotal] = useState(0)
  const [oototal, setoototal] = useState(0)

  const [verified, setVerified] = useState(0)
  const [sampled, setSampled] = useState(0)
  const [handled, setHandled] = useState(0)
  const [completed, setCompleted] = useState(0)

  const [districtData, setDistrictData] = useState([])
  

  useEffect(()=>{
    axios.get(url.DASHPAYMENTDISTRICTS, Config).then((r)=>{
      setDistrictData(r.data)
    }).catch((e)=>{
      console.log(e)
    })
    axios.get(url.DASHPAYMENTS, Config).then((r)=>{
      setDates(r.data[0].map(item => item.date))
      setAmounts(r.data[0].map(item => parseFloat(item.amount)))
      setAmountsz(r.data[1].map(item => parseFloat(item.amount)))
      setAmountse(r.data[2].map(item => parseFloat(item.amount)))
      let total = 0
      let ar = []
      r.data[0].map(item =>{
        total +=parseFloat(item.amount)
      })
      let ztotal = 0
      r.data[1].map(item =>{
        ztotal +=parseFloat(item.amount)
      })
      setzztotal(ztotal.toFixed(1))
      let etotal = 0
      r.data[2].map(item =>{
        etotal +=parseFloat(item.amount)
      })
      seteetotal(etotal.toFixed(1))
      ar.push(parseFloat(((ztotal/total)*100).toFixed(1)))
      ar.push(parseFloat(((etotal/total)*100).toFixed(1)))
      ar.push(0)
      setSeries1(ar)

      axios.get(url.DASHGAUGES, Config).then((r)=>{
        setVerified(r.data[0].verified)
        setSampled(r.data[1].sampled)
        setHandled(r.data[2].handled)
        setCompleted(r.data[3].completed)

      }).catch((e)=>{
        console.log(e)
      })
    }).catch((e)=>{
      console.log(e)
    })
  },[])

  const options = {
    chart: {
      toolbar: { show: false}
    },
    dataLabels: { 
      enabled: false,
      style: {
        colors: ["#1a75ff", "#4dff88", "#ffd280"],
        fontSize: '12px',
        fontFamily: 'Helvetica, Arial, sans-serif',
        fontWeight: 'bold'
      },
      background: {
        enabled: true,
        borderRadius:10,
        foreColor: '#fff',
        padding: 4,
      }, 
      
    },
    stroke: { 
      curve: "smooth", 
      width: 7 
    },
    markers: { size: 3, style: "hollow" },
    xaxis: {
      categories: dates,
    },
    yaxis: {
      title: {
        text: 'Million SLSH',
      },
    },
    title: {
      align: 'center',
    },
    colors: ["#1a75ff", "#4dff88", "#ffd280"],
  };
  const series =  [
    {
      name: 'Total',
      data: amounts,
      type: 'line',
      color: '#1a75ff', 
    },
    {
      name: 'ZAAD',
      data: amountsz,
      type: 'line',
      color: '#4dff88', 
    },
    {
      name: 'eDahab',
      data: amountse,
      type: 'line',
      color: '#ffd280', 
    },
  ]
  //const series1 = [ze, de, 0];
  const options1 = {
    labels: ["ZAAD", "eDahab", "others"],
    colors: ["#4dff88", "#ffd280", "#ccc"],
    legend: { show: !1 },
    plotOptions: {
      pie: {
        donut: {
          size: "60%",
        },
      },
    },
  };
  const optionsD = {
    chart: {
      type: 'bar',
      height: 350
    },
    xaxis: {
      categories: districtData && Object.keys(districtData)
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded'
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    legend: {
      position: 'top'
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: function (val) {
          return val + " M";
        }
      }
    }
  };

  const transposedData = {};
  const totals = [];
  Object.keys(districtData).forEach(month => {
    let monthTotal = 0;
    Object.keys(districtData[month]).forEach(letter => {
      const value = parseFloat(districtData[month][letter]);
      monthTotal += value;
      if (!transposedData[letter]) {
        transposedData[letter] = [];
      }
      transposedData[letter].push(value);
    });
    totals.push(monthTotal);
  });

  let seriesD = Object.keys(transposedData).map(letter => ({ name: letter, type: 'column', data: transposedData[letter]}));

  //seriesD.push({name:'Total', type: 'line', data: totals})




  return (
    <React.Fragment>
    <Col xl="3">
        <Card>
          <CardBody>
          <div>
          <p className="text-muted mb-0">Payments Verified</p>
          <GaugeComponent
          
              value={verified}
              type="radial"
              labels={{
                tickLabels: {
                  type: "outer",
                  ticks: [
                    { value: 20 },
                    { value: 40 },
                    { value: 60 },
                    { value: 80 },
                    { value: 100 }
                  ]
                }
              }}
              arc={{
                colorArray: ['#EA4228','#5BE12C'],
                subArcs: [{limit: 10}, {limit: 30}, {}, {}, {}],
                padding: 0.02,
                width: 0.3
              }}
              pointer={{
                elastic: true,
                animationDelay: 0
              }}
          
           />
          </div>
          </CardBody>
        </Card>
      </Col>
      <Col xl="3">
        <Card>
          <CardBody>
          <div>
          <p className="text-muted mb-0">Water Sampled</p>
          <GaugeComponent
          
              value={sampled}
              type="radial"
              labels={{
                tickLabels: {
                  type: "outer",
                  ticks: [
                    { value: 20 },
                    { value: 40 },
                    { value: 60 },
                    { value: 80 },
                    { value: 100 }
                  ]
                }
              }}
              arc={{
                colorArray: ['#EA4228','#5BE12C'],
                subArcs: [{limit: 10}, {limit: 30}, {}, {}, {}],
                padding: 0.02,
                width: 0.3
              }}
              pointer={{
                elastic: true,
                animationDelay: 0
              }}
          
           />
          </div>
          </CardBody>
        </Card>
      </Col>
      <Col xl="3">
        <Card>
          <CardBody>
          <div>
          <p className="text-muted mb-0">Customer Complaints Handled</p>
          <GaugeComponent
          
              value={handled}
              type="radial"
              labels={{
                tickLabels: {
                  type: "outer",
                  ticks: [
                    { value: 20 },
                    { value: 40 },
                    { value: 60 },
                    { value: 80 },
                    { value: 100 }
                  ]
                }
              }}
              arc={{
                colorArray: ['#EA4228','#5BE12C'],
                subArcs: [{limit: 10}, {limit: 30}, {}, {}, {}],
                padding: 0.02,
                width: 0.3
              }}
              pointer={{
                elastic: true,
                animationDelay: 0
              }}
          
           />
          </div>
          </CardBody>
        </Card>
      </Col><Col xl="3">
        <Card>
          <CardBody>
          <div>
          <p className="text-muted mb-0">Maintenance Jobs Completed</p>
          <GaugeComponent
          
              value={completed}
              type="radial"
              labels={{
                tickLabels: {
                  type: "outer",
                  ticks: [
                    { value: 20 },
                    { value: 40 },
                    { value: 60 },
                    { value: 80 },
                    { value: 100 }
                  ]
                }
              }}
              arc={{
                colorArray: ['#EA4228','#5BE12C'],
                subArcs: [{limit: 10}, {limit: 30}, {}, {}, {}],
                padding: 0.02,
                width: 0.3
              }}
              pointer={{
                elastic: true,
                animationDelay: 0
              }}
          
           />
          </div>
          </CardBody>
        </Card>
      </Col>
      <Col xl="8">
        <Card>
          <CardBody>
            <h4 className="card-title mb-3">Bill Payment Trend</h4>
            <div>
              <div id="overview-chart" className="apex-charts" dir="ltr">
           
                <div id="overview-chart-timeline">
                  <ReactApexChart options={options} series={series} type="line" height={400} />
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
      
      
      <Col xl="4">
        <Card>
          <CardBody>
          <h4 className="card-title mb-3">Service Provider</h4>
          <div>
              <div id="donut-chart">
                <ReactApexChart
                  options={options1}
                  series={series1}
                  type="donut"
                  height={358}
                  className="apex-charts"
                />
              </div>
            </div>

            <div className="text-center text-muted">
              <Row>
                <Col xs="4">
                  <div className="mt-4">
                    <p className="mb-2 text-truncate">
                    <i className="mdi mdi-circle me-1" style={{ color: '#009933' }} />ZAAD
                    </p>
                    <h5>{zztotal}M</h5>
                  </div>
                </Col>
                <Col xs="4">
                  <div className="mt-4">
                    <p className="mb-2 text-truncate">
                    <i className="mdi mdi-circle me-1" style={{ color: '#ffa500' }} />eDahab
                    </p>
                    <h5>{eetotal}M</h5>
                  </div>
                </Col>
                <Col xs="4">
                  <div className="mt-4">
                    <p className="mb-2 text-truncate">
                    <i className="mdi mdi-circle me-1" style={{ color: '#ccc' }} />Others
                    </p>
                    <h5>{oototal}M</h5>
                  </div>
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>
      </Col>
      <Col xl="12">
        <Card>
          <CardBody>
            <h4 className="card-title mb-3">Payment by District</h4>
            <hr className="mb-4" />
            <div>
              <div id="overview-chart" className="apex-charts" dir="ltr">
           
                <div id="overview-chart-timeline">
                  <ReactApexChart options={optionsD} series={seriesD} type="bar" height={350} />
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
      
    </React.Fragment>
  );
};

export default Oerview;
